export const setLocation =  (data) => ({
    type: 'SET_LOCATION',
    data
});

export const setLocationError = (data) => ({
    type: 'SET_LOCATION_ERROR',
    data
});